<div class="items-frame-wrapper">
  <button
    [ngStyle]="
      itemsFrame.button | fontFamily | assign : showProductsButtonStyles
    "
    (click)="itemsOpened = !itemsOpened"
    class="btn btn-default btn-lightish-blue min-w mb-0 show expand-button"
  >
    <div
      (click)="selectFrameButton('orderItemsFrameButton', $event)"
      class="visual-builder-block z-1"
      [class.selected]="selectedId?.id?.includes('orderItemsFrameButton')"
    >
      {{
        itemsOpened
          ? ('btn_hide_products' | translate)
          : ('btn_show_products' | translate)
      }}
    </div>
  </button>
  <div
    (click)="selectFrameItem('orderItemsFrame', $event)"
    class="visual-builder-block z-0"
    [class.selected]="selectedId?.id === 'orderItemsFrame'"
  >
    <div
      [class.open]="itemsOpened"
      [class.closed]="!itemsOpened"
      [ngStyle]="{
        backgroundColor: itemsFrame?.backgroundColor,
        borderColor: itemsFrame?.borderColor,
        'borderWidth.px': itemsFrame?.borderWidth,
        'borderRadius.px': itemsFrame?.borderRadius,
        'box-shadow': itemsFrame?.shadow
      }"
      class="shipping-items"
    >
      <div
        #orderItemContainer
        class="wrapper"
        [ngStyle]="{
          'overflow-y': itemsFrame.scroll ? 'auto' : 'unset',
          'max-height.px': itemsFrame.scroll ? orderItemHeight : 'unset'
        }"
      >
        <app-tracking-page-order-item
          *ngFor="let item of items"
          [itemCard]="itemsFrame?.itemCard"
          [item]="item"
          [selectedId]="selectedId"
          (selectBlock)="selectBlock.emit($event)"
        >
        </app-tracking-page-order-item>
      </div>
    </div>
  </div>
</div>
